import cloneDeep from 'lodash.clonedeep';
import types from './actionTypes';
import clusterlets from '../../../test/clusterlets'
import { controlDelegate } from '../../../config/control_delegate';


const initialState = [] //clusterlets

export default function appReducer(state = initialState, action) {
  
  switch (action.type) {
    case types.ADD_CLUSTERLET: {
      return [
        ...state,
        action.payload
      ]
    }

    case types.EDIT_CLUSTERLET: {
      return [...state.map(clusterlet => clusterlet?.id == action?.payload?.id ? (action.payload) : ({ ...clusterlet }))]
    }

    case types.DELETE_CLUSTERLET: {
      // console.log("action", action, state)
      return state.filter(clusterlet => clusterlet.id !== action.payload.id)

    }

    case 'RESET_BLUEPRINT':
      return cloneDeep(initialState);


    case 'UPDATE_FULL_CLUSTERLETS':
      return [
        ...state,
        ...action.payload
      ]

    case 'RESET_CLUSTERLETS':
      return [
        ...action.payload
      ]

    case types.SET_REACT_FLOW_INSTANCE:
    // console.log("action", action)
    // return {
    //   ...state,
    //   reactFlowInstance: action.payload,
    // };


    default:
      return state;
  }
}
